// for Injectable
export { DwIamMenuRepository } from './iam-menu-repository';
export { DwIamPermissionRepository } from './iam-permission-repository';
export { DwIamUserRepository } from './iam-user-repository';
